import React from "react";
import styles from "./PersonalModule.module.scss";
import { AnswerTab } from "../../components/AnswerTab/AnswerTab";
import { MessageIcon } from "../../../../assets/icons/MessageIcon";
import { UserHeadsetIcon } from "../../../../assets/icons/UserHeadsetIcon";
import { SparklesIcon } from "../../../../assets/icons/SparklesIcon";
import {
  setNewAssistant,
  setUpdateAssistant,
} from "../../../../store/slices/assistantSlice";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "../../ui/Select/Select";
import { Input } from "../../components/Input/Input";
import { Button } from "../../ui/Button/Button";
import { TrashIcon } from "../../../../assets/icons/TrashIcon";
import { ToggleSwitch } from "../../ui/ToggleSwitcher/ToggleSwitcher";
import TimeZoneSelector from "../../components/TimeZoneSelector/TimeZoneSelector";

const answerData = ["Ты", "Вы"];

const communicationStyles = [
  { value: "formal", label: "Деловой" },
  { value: "friendly", label: "Дружелюбный" },
  { value: "neutral", label: "Нейтральный" },
  { value: "informal", label: "Неформальный" },
  { value: "humorous", label: "Юмористический" },
  { value: "concise", label: "Сдержанный" },
  { value: "empathetic", label: "Эмпатичный" },
  { value: "educational", label: "Обучающий" },
  { value: "authoritative", label: "Авторитетный" },
  { value: "roleplay", label: "Игровой / Ролевой" },
];

export const PersonalModule = ({ newAssistant }) => {
  const dispatch = useDispatch();

  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const appeal = newAssistant?.appeal || "";
  const useTimePeriod =
    updateAssistant?.settings?.useTimePeriod ||
    newAssistant?.settings?.useTimePeriod ||
    false;
  const startWorkTime =
    updateAssistant?.settings?.startWorkTime ||
    newAssistant?.settings?.startWorkTime ||
    "";
  const endWorkTime =
    updateAssistant?.settings?.endWorkTime ||
    newAssistant?.settings?.endWorkTime ||
    "";

  const actions = newAssistant?.actions || [];

  const handleSetAppeal = (value) => {
    const updatedAssistant = { ...newAssistant, appeal: value };
    dispatch(setNewAssistant(updatedAssistant));
  };

  const handleStyleChange = (value) => {
    const updatedAssistant = { ...newAssistant, communicationStyle: value };
    dispatch(setNewAssistant(updatedAssistant));
  };

  const handleActionChange = (index, field, newValue) => {
    const updatedAssistant = { ...newAssistant };

    const updatedActions = [...(updatedAssistant.actions || [])];

    if (!updatedActions[index]) {
      updatedActions[index] = { action: "", result: "" };
    }
    
    updatedActions[index] = {
      ...updatedActions[index],
      [field]: newValue,
    };

    updatedAssistant.actions = updatedActions;
    dispatch(setNewAssistant(updatedAssistant));
  };

  const handleAddAction = () => {
    const updatedAssistant = { ...newAssistant };
    const updatedActions = [...(updatedAssistant.actions || [])];
    updatedActions.push({ action: "", result: "" });
    updatedAssistant.actions = updatedActions;
    dispatch(setNewAssistant(updatedAssistant));
  };

  const handleDeleteAction = (index) => {
    const updatedAssistant = { ...newAssistant };
    if (!updatedAssistant.actions) return;

    const updatedActions = [...updatedAssistant.actions];
    updatedActions.splice(index, 1);
    updatedAssistant.actions = updatedActions;

    dispatch(setNewAssistant(updatedAssistant));
  };

  const toggleObserver = (bool) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: { ...newAssistant.settings, useTimePeriod: bool },
      };
      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: { ...updateAssistant.settings, useTimePeriod: bool },
      };
      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const handlerStartWorkTime = (value) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          startWorkTime: value,
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          startWorkTime: value,
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const handlerEndWorkTime = (value) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          endWorkTime: value,
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          endWorkTime: value,
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  return (
    <div className={styles.wrapper}>
      {!updateAssistant && (
        <div className={styles.container}>
          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <MessageIcon size={16} fill={"#212121"} />
              </div>
              <p>Обращение</p>
            </div>
            <div className={styles.answerTabsWrapper}>
              <div className={styles.answerTabs}>
                {answerData.map((item) => (
                  <AnswerTab
                    key={item}
                    value={item}
                    active={item === appeal}
                    onClick={() => handleSetAppeal(item)}
                  />
                ))}
              </div>
              <div className={styles.smallText}>
                Выберите как ассистент будет обращаться к клиенту
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <UserHeadsetIcon width={16} height={21} fill={"#212121"} />
              </div>
              <p>Стиль общения</p>
            </div>
            <Select
              options={communicationStyles}
              value={newAssistant?.communicationStyle || null}
              onChange={handleStyleChange}
              placeholder="Выберите стиль..."
            />
            <small>
              Определите тон общения, чтобы ассистент соответствовал ожиданиям
              вашей аудитории
            </small>
          </div>
        </div>
      )}

      {!updateAssistant && (
        <div className={styles.container} style={{ alignItems: "end" }}>
          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <SparklesIcon size={16} fill={"#212121"} />
              </div>
              <p>Действия</p>
            </div>

            {actions.map((item, index) => (
              <div className={styles.inputs} key={index}>
                <Input
                  value={item.action}
                  placeholder="Действие"
                  onChange={(value) =>
                    handleActionChange(index, "action", value)
                  }
                />
                <Input
                  value={item.result}
                  placeholder="Результат"
                  onChange={(value) =>
                    handleActionChange(index, "result", value)
                  }
                />
                <div
                  className={styles.delete}
                  onClick={() => handleDeleteAction(index)}
                >
                  <TrashIcon width={18} height={16} fill={"#E90000"} />
                </div>
              </div>
            ))}

            <small>
              Настройте реакцию ассистента: если пользователь говорит что-то →
              ассистент выполняет действие
            </small>

            <div className={styles.button}>
              <Button title={"Добавить"} onClick={handleAddAction} />
            </div>
          </div>
        </div>
      )}

      <div className={styles.container}>
        <div className={styles.item}>
          <div className={styles.toggleSwitcher}>
            <div className={styles.switcherContainer}>
              <ToggleSwitch
                bool={useTimePeriod}
                onToggle={toggleObserver}
              />
              <p className={styles.switcherText}>Работа в определенные часы</p>
            </div>
            <p className={styles.smallText}>
              Укажите временной интервал, в который ассистент будет активен, и
              выберите ваш часовой пояс. Это позволит ассистенту работать строго
              по вашему локальному времени. В остальное время ассистент не будет
              отвечать на сообщения.
            </p>
          </div>

          {useTimePeriod && (
            <div className={styles.toggleContent}>
              <div className={styles.selectContainer}>
                <div className={styles.select}>
                  <div className={styles.titleSelect}>Временная зона</div>
                  <TimeZoneSelector
                    newAssistant={newAssistant}
                    updateAssistant={updateAssistant}
                  />
                </div>
                <div className={styles.smallText}>
                  Выберите подходящий для вас часовой пояс
                </div>
              </div>
              <div className={styles.toggleInputs}>
                <div className={styles.toggleInputRow}>
                  <Input
                    labelStyle={styles.labelTime}
                    useTime={true}
                    value={startWorkTime}
                    label={"От"}
                    placeholder={"От"}
                    onChange={handlerStartWorkTime}
                  />
                  <Input
                    labelStyle={styles.labelTime}
                    useTime={true}
                    value={endWorkTime}
                    label={"До"}
                    placeholder={"До"}
                    onChange={handlerEndWorkTime}
                  />
                </div>
                <div className={styles.smallText}>
                  Укажите временной интервал, когда ассистент будет активен в
                  чате
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
